import { render, staticRenderFns } from "./Woocommerce.vue?vue&type=template&id=7595c65a&"
import script from "./Woocommerce.vue?vue&type=script&lang=js&"
export * from "./Woocommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports